// src/components/helpers/FormRadioGroup.js
import React, { memo } from "react";
import FormControl from "@mui/material/FormControl";
import FormLabel from "@mui/material/FormLabel";
import RadioGroup from "@mui/material/RadioGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import Radio from "@mui/material/Radio";
import FormHelperText from "@mui/material/FormHelperText";

function FormRadioGroup({
  label,
  name,
  value,
  onChange,
  options,
  row = false,
  isReadOnly = false,
  status,
  error,
  helperText,
  ...props
}) {
  const getColor = () => {
    switch (status) {
      case "error":
        return "#f44336";
      case "warning":
        return "#ffd500";
      case "success":
        return "#4caf50";
      default:
        return "";
    }
  };

  return (
    <FormControl
      component="fieldset"
      error={status === "error"}
      sx={{
        border: status ? `1px solid ${getColor()}` : "none",
        borderRadius: "4px",
        padding: "8px",
        paddingLeft: "20px",
      }}
    >
      <FormLabel component="legend" className="bold-text">
        {label}
      </FormLabel>
      <RadioGroup
        aria-label={name}
        name={name}
        value={value}
        onChange={onChange}
        row={row}
      >
        {options.map((option) => (
          <FormControlLabel
            key={option.value}
            value={option.value}
            control={<Radio />}
            label={option.label}
            disabled={isReadOnly}
            sx={{
              paddingRight: 1,
              "& .MuiFormControlLabel-label": {
                paddingLeft: 1,
              },
            }} // Adjust spacing
          />
        ))}
      </RadioGroup>
      {helperText && <FormHelperText>{helperText}</FormHelperText>}
    </FormControl>
  );
}

export default memo(FormRadioGroup);
